import React from 'react';
import ToastMessage from '../../components/ToastMessage';
import { Accordion, AccordionSummary, Box, Button } from '@mui/material';
import {
  AccordionHeading,
  FixedHeaderBox,
  FormHeader,
  StyledAccordionDetails
} from '../SchoolConfig/styled';
import { FormFieldSchema } from '../../components/FormRenderer/types';
import { getPaymentConfigSchema } from './config/schema';
import Icons from '../../components/icons';
import FormRenderer from '../../components/FormRenderer/FormRenderer';
import { usePaymentConfig } from './config/usePaymentConfig';
import { canAccessField } from '../../utils/roleAccess';

const PaymentConfig = () => {
  const {
    control,
    expandedSection,
    toastOpen,
    toastMessage,
    toastSeverity,
    userRole,
    gradeOptions,
    handleAccordionChange,
    handleSubmit,
    handleFileUpload,
    setToastOpen,
    setValue
  } = usePaymentConfig();

  const filteredSchema = React.useMemo(() => {
    return getPaymentConfigSchema(gradeOptions).filter((section) => {
      if (!section.allowedRoles) return true;
      return canAccessField(userRole, section.allowedRoles);
    });
  }, [userRole, gradeOptions]);

  function getFieldsToRenderForSection(
    section: FormFieldSchema
  ): FormFieldSchema[] {
    const isSectionArrayTypeWithSectionsName =
      section.type === 'array' && section.name === 'sections';
    if (isSectionArrayTypeWithSectionsName) {
      return (section as any).children || [];
    }
    return [section];
  }

  return (
    <>
      <form onSubmit={handleSubmit}>
        <FixedHeaderBox>
          <FormHeader>Payment Configuration</FormHeader>
          <Button variant='contained' type='submit' color='primary'>
            Save Settings
          </Button>
        </FixedHeaderBox>
        {filteredSchema.map((section: FormFieldSchema, index: number) => {
          const fieldsToRenderForCurrentSection =
            getFieldsToRenderForSection(section);

          return (
            <Box key={section.name} marginTop={index === 0 ? 11 : 1}>
              <Accordion
                expanded={expandedSection === section.name}
                onChange={handleAccordionChange(section.name)}
              >
                <AccordionSummary expandIcon={<Icons.CaretDown />}>
                  <AccordionHeading>{section.label}</AccordionHeading>
                </AccordionSummary>
                <StyledAccordionDetails>
                  <FormRenderer
                    control={control}
                    schema={fieldsToRenderForCurrentSection}
                    handleFileUpload={handleFileUpload}
                    setValue={setValue}
                  />
                </StyledAccordionDetails>
              </Accordion>
            </Box>
          );
        })}
      </form>
      <ToastMessage
        open={toastOpen}
        message={toastMessage}
        severity={toastSeverity}
        onClose={() => setToastOpen(false)}
      />
    </>
  );
};

export default PaymentConfig;
